/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type TradePromo_item$ref = any;
export type PdpSharedPromoCode_item$ref = any;
export type PdpSharedPromoCode_item = {
    readonly " $fragmentRefs": TradePromo_item$ref;
    readonly " $refType": PdpSharedPromoCode_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedPromoCode_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "TradePromo_item",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'ea46f36575e44c5e9545ccb796db55f6';
export default node;
